import { Component, ElementRef, inject, ViewChild } from '@angular/core';

import { PosthogService } from '~shared/services/posthog.service';

import { PodcastListItemComponent } from '../podcast-list-item/podcast-list-item.component';

import { GlobalPodcastPlayerService } from './global-podcast-player.service';

@Component({
  selector: 'app-global-podcast-player',
  imports: [PodcastListItemComponent],
  templateUrl: './global-podcast-player.component.html',
})
export class GlobalPodcastPlayerComponent {
  @ViewChild('audioPlayer') audioPlayer: ElementRef<HTMLAudioElement>;

  globalPodcastService = inject(GlobalPodcastPlayerService);
  posthogService = inject(PosthogService);

  currentPodcast = this.globalPodcastService.currentPodcast;
  showPlayer = this.globalPodcastService.showPlayer;

  onPlay() {
    // if (this.currentPodcast()) {
    //   this.posthogService.trackPodcastPlayed(
    //     this.currentPodcast().companyTicker,
    //     this.currentPodcast().research_date
    //   );
    // }
  }

  close() {
    if (this.audioPlayer) {
      this.audioPlayer.nativeElement.pause();
    }
    this.globalPodcastService.stopPodcast();
  }
}
